export const GROUP_NAME = 'inputFile'

export enum Variants {
  Display = 'display',
  Primary = 'primary',
  Secondary = 'secondary',
  Text = 'text',
}

export const DEFAULT_VARIANT = Variants.Primary
